const getCriticalError = (rootState) => rootState.error.criticalError;

export default getCriticalError;
